import { PolygonMarkerStyleSection } from 'components/minute/sidebar/MarkerSidebar/PolygonMarkerSidebar/PolygonMarkerStyleSection';
import { MarkerControlsSection } from 'components/minute/sidebar/MarkerSidebar/shared/MarkerControlsSection';
import { MarkerCoordinatesSection } from 'components/minute/sidebar/MarkerSidebar/shared/MarkerCoordinatesSection';
import { MarkerFloorSection } from 'components/minute/sidebar/MarkerSidebar/shared/MarkerFloorSection';
import { useContext } from 'react';
import { IPolygonV2WorldMarker } from 'react-give-me-map';
import { CtxEdit } from 'session/ctxEdit';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
    marker: IPolygonV2WorldMarker;
}

export const PolygonMarkerSidebar = (props: Props): JSX.Element => {
    const ctxEdit = useContext(CtxEdit);
    return (
        <S_PolygonMarkerSidebar className={props.className}>
            <MarkerCoordinatesSection
                coordinates={props.marker.elementData.coordinates}
                onCoordinatesChange={(coordinates) => {
                    ctxEdit.updateWorldMarkerData(props.marker.id, { coordinates });
                }}
            />
            <PolygonMarkerStyleSection marker={props.marker} />
            <MarkerFloorSection marker={props.marker} />
            <MarkerControlsSection marker={props.marker} />
        </S_PolygonMarkerSidebar>
    );
};

const S_PolygonMarkerSidebar = styled.div``;
